export default __webpack_public_path__ + "static/media/red-circle.d57de410.webp";